import moment from "moment-timezone";
import React, { useState } from "react";

import DatePicker from "../DatePicker";
import FormikInput from "../FormikInput";
import images from "../../../utils/images";

import "./style.scss";

const DatePickerWithDisplay = (props) => {
  const { dateClickHandler, dateStr, formEl, formikProps, touched } = props;

  const [showDatePicker, setShowDatePicker] = useState(false);

  return (
    <>
      <div className="d-flex">
        <FormikInput
          disabled="disabled"
          errors={formikProps.errors}
          formEl={formEl}
          inputClasses={formEl.inputClasses}
          touched={formikProps.touched}
        />
        <div
          className="cursor"
          onClick={() => setShowDatePicker(!showDatePicker)}
          role="button"
          style={{
            marginLeft: 10,
            marginTop: formEl.inputClasses && formEl.inputClasses.includes("Input--sm") ? 37 : 42,
          }}
        >
          <img alt="pick date" src={images("./icons/calender-icon.svg")} />
        </div>
      </div>
      {showDatePicker && (
        <div className="inline-date-picker">
          <DatePicker
            externalCtx={dateStr ? moment(dateStr, "MM/DD/YYYY") : null}
            onDaySelect={(dateStr, eventType) => {
              touched && touched();

              dateClickHandler(dateStr, eventType, formEl);
              if (eventType !== "monthChange") {
                setShowDatePicker(false);
              }
            }}
          />
        </div>
      )}
    </>
  );
};

export default DatePickerWithDisplay;
